import { render, staticRenderFns } from "./DocumentTypeTable.vue?vue&type=template&id=1c1b3f49&scoped=true&"
import script from "./DocumentTypeTable.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeTable.vue?vue&type=style&index=0&id=1c1b3f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b3f49",
  null
  
)

export default component.exports